<template>
  <div class="ourDocument margin-general">
    <div>
      <div class="">
        <h2 class="title">{{ $t("forms_and_documents.ourDocument") }}</h2>
        <p class="sub-title body-4 text-container-md">
          {{ $t("forms_and_documents.descrOurDocument") }}
          <a href="mailto:support@tradeview.eu"> support@tradeview.eu.</a>
        </p>
        <p class="sub-title body-4-bold text-container-md">
          {{ $t("forms_and_documents.selectOurDocument") }}
        </p>
      </div>
    </div>
    <div>
      <TabbedSelector
        :selected="selectedTab"
        :tabs="tabs"
        @selected="tabSelected"
      ></TabbedSelector>

      <!--    ACCOUNT    -->
      <section class="application" v-if="selectedTab === 'account'">
        <div class="forms-files">
          <div
            v-for="(frm, index) in filteredForms1"
            :key="index + 'form1'"
            class="form"
          >
            <a :href="frm.url" target="_blank" rel="noopener noreferrer">
              <p class="body-4">{{ $t(frm.body) }}</p>
            </a>
            <div class="icon">
              <a :href="frm.url" target="_blank" rel="noopener noreferrer">
                <span class="material-symbols-outlined" translate="no">download</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section class="application" v-if="selectedTab === 'documents'">
        <div class="forms-files">
          <div
            v-for="(frm, index) in filteredForms2"
            :key="index + 'form1'"
            class="form"
          >
            <p class="body-4">{{ $t(frm.body) }}</p>
            <div class="icon">
              <a :href="frm.url" target="_blank" rel="noopener noreferrer">
                <span class="material-symbols-outlined" translate="no">download</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <button @click="downloadSelectedFile" class="body-4-bold second-button-small download">
        {{ $t("forms_and_documents.downloadAll") }}
      </button>
    </div>
  </div>
</template>

<script>
import TabbedSelector from "@/components/forms_and_documents/TabbedSelector";
import { ref, computed, onMounted } from 'vue';
import { useI18n } from "vue-i18n";

export default {
  components: {
    TabbedSelector,
  },
  setup() {
    const { t, locale } = useI18n();

    let selectedTab = ref(null);
    let tabs = ref([
      {
        label: "forms_and_documents.tab_account1",
        value: "account",
      },
      {
        label: "forms_and_documents.tab_account2",
        value: "documents",
      },
    ]);
    const downloadFilesMap = {
      account: "images/forms_and_documents/Account_opening_form_ltd.zip",
      documents: "images/forms_and_documents/Documents_and_agreements_ltd.zip",
    };


    let forms1 = ref([
      {
        body: "forms_and_documents.account1",
        url: "/documents/ClientAgreement.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.account2",
        url: "/documents/CorporateAccountApplicationForm.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.account3",
        url: "/documents/CorporateAccountApplicationFormAnnexI.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.account4",
        url: "/documents/Individual_JointClientApplicationForm.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.account5",
        url: "/documents/W8BEN.pdf",
        hiddenLocales: [],
      },
    ]);

    let forms2 = ref([
      {
        body: "forms_and_documents.document1",
        url: "/documents/AccountAndTradingFees.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document2",
        url: "/documents/AdditionalRiskDisclosure.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document3",
        url: "/documents/AMLPolicy.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document4",
        url: "/documents/BestExecutionAndClientOrderHandlingPolicy.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document5",
        url: "/documents/CommissionAgreement.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document6",
        url: "/documents/ComplaintsprocedureEU.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document7",
        url: "/documents/ConsenttoDeliveryofStatementsbyElectronicMedia.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document8",
        url: "/documents/CookiePolicy.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document9",
        url: "/documents/CorporateResolutionsAndCertificate.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document10",
        url: "/documents/ElectronicTradingAgreement.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document11",
        url: "/documents/KIDCFDsonanIndex.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document12",
        url: "/documents/KIDCFDsonCommodities.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document13",
        url: "/documents/KIDCFDsonCryptocurrency.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document14",
        url: "/documents/KIDCFDsonForex.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document15",
        url: "/documents/PrivacyPolicy.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document16",
        url: "/documents/RefundPolicy.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document17",
        url: "/documents/RiskDisclosure.pdf",
        hiddenLocales: [],
      },
      {
        body: "forms_and_documents.document18",
        url: "/documents/TermsandConditions.pdf",
        hiddenLocales: [],
      },
    ]);

    onMounted(() => {
      selectedTab.value = "account";
    });

    const tabSelected = (value) => {
      selectedTab.value = value;
    };

    const downloadSelectedFile = () => {
      const filePath = downloadFilesMap[selectedTab.value];
      if (!filePath) {
        console.error("Archivo no encontrado para el tab seleccionado.");
        return;
      }
      const fullPath = `/${filePath}`; // Ensure a leading slash
      forceDownload(fullPath);
    };

    const forceDownload = (url) => {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const filteredForms1 = computed(() => {
      return forms1.value
        .filter(form => !form.hiddenLocales.includes(locale.value))
        .sort((a, b) => {
          const titleA = t(a.body).toLowerCase();
          const titleB = t(b.body).toLowerCase();
          return titleA.localeCompare(titleB);
        });
    });

    const filteredForms2 = computed(() => {
      return forms2.value
        .filter(form => !form.hiddenLocales.includes(locale.value))
        .sort((a, b) => {
          const titleA = t(a.body).toLowerCase();
          const titleB = t(b.body).toLowerCase();
          return titleA.localeCompare(titleB);
        });
    });


    return {
      selectedTab,
      tabs,
      tabSelected,
      forms1,
      forms2,
      filteredForms1,
      filteredForms2,
      downloadSelectedFile
    };
  },
};
</script>
